export default function () {
    document.addEventListener('alpine:init', () => {
        const screenWidth = window.innerWidth;

        if (screenWidth > 412) {
            if (!localStorage.getItem('animation-played')) {
                document.body.classList.add('is-animating');
                localStorage.setItem('animation-played', 'true');

                setTimeout(function() {
                    document.body.classList.remove('is-animating');
                }, 4500);
            }
        } else {
            const openingAnimation = document.querySelector('.start-animation') as HTMLElement;
            if (openingAnimation) {
                openingAnimation.style.display = 'none';
            }
        }
    });
}
